export default __webpack_public_path__ + "static/media/cake8.78c56ebc.jpg";